import { render, staticRenderFns } from "./SwitchTransition.vue?vue&type=template&id=343e40ea&"
import script from "./SwitchTransition.vue?vue&type=script&lang=js&"
export * from "./SwitchTransition.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTransition.vue?vue&type=style&index=0&id=343e40ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports